/* V8 PRODUCT — Shopify behaviour for the approved HTML layout */
(() => {
  const initialise = (root) => {
    if (!root || root.dataset.esProductReady === 'true') return;
    const variantsNode = root.querySelector('[data-es-product-variants]');
    const form = root.querySelector('[data-es-product-form]');
    if (!variantsNode || !form) return;

    let variants;
    try {
      variants = JSON.parse(variantsNode.textContent);
    } catch (_) {
      return;
    }

    root.dataset.esProductReady = 'true';
    const selects = [...root.querySelectorAll('[data-es-option-index]')];
    const variantInput = root.querySelector('[data-es-variant-id]');
    const sku = root.querySelector('[data-es-product-sku]');
    const skuRow = root.querySelector('[data-es-product-sku-row]');
    const exPrice = root.querySelector('[data-es-product-price-ex]');
    const incPrice = root.querySelector('[data-es-product-price-inc]');
    const stock = root.querySelector('[data-es-product-stock]');
    const addButton = root.querySelector('[data-es-add-button]');
    const addLabel = root.querySelector('[data-es-add-label]');
    const quantity = root.querySelector('[data-es-quantity-input]');

    const update = () => {
      const values = selects.map((select) => select.value);
      // Products with only Shopify's default variant do not render option
      // selects. In that case, retain the variant Liquid placed in the form
      // instead of trying to match an empty option array against
      // ["Default Title"].
      const currentVariantId = variantInput?.value;
      const variant = selects.length === 0
        ? variants.find((item) => String(item.id) === String(currentVariantId))
          || variants.find((item) => item.available)
          || variants[0]
        : variants.find((item) =>
          item.options.length === values.length &&
          item.options.every((value, index) => value === values[index])
        );

      if (!variant) {
        if (addButton) addButton.disabled = true;
        if (addLabel) addLabel.textContent = 'Unavailable';
        if (stock) {
          stock.textContent = 'This option combination is unavailable';
          stock.classList.add('is-sold-out');
        }
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (sku) sku.textContent = variant.sku || '';
      if (skuRow) skuRow.hidden = !variant.sku;
      if (exPrice) exPrice.textContent = variant.price_ex;
      if (incPrice) incPrice.textContent = variant.price_inc;
      if (addButton) addButton.disabled = !variant.available;
      if (addLabel) addLabel.textContent = variant.available ? 'Add to cart' : 'Sold out';
      if (stock) {
        stock.textContent = variant.available
          ? 'In stock — usually dispatched within 1–2 working days'
          : 'Currently unavailable';
        stock.classList.toggle('is-sold-out', !variant.available);
      }

      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    };

    selects.forEach((select) => select.addEventListener('change', update));
    root.querySelector('[data-es-quantity-minus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) - 1));
    });
    root.querySelector('[data-es-quantity-plus]')?.addEventListener('click', () => {
      quantity.value = String(Math.max(1, Number(quantity.value || 1) + 1));
    });
    update();
  };

  const initialiseAll = (scope = document) => {
    scope.querySelectorAll('[data-es-product]').forEach(initialise);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialiseAll());
  } else {
    initialiseAll();
  }
  document.addEventListener('shopify:section:load', (event) => initialiseAll(event.target));
})();
